import React, { useEffect, useState } from "react";
import { Dropdown, Modal, Nav, Tab } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import swal from "sweetalert";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import Loader from "../Loader/Loader";
import { get_CategoryRedirect } from "../../../store/actions/CommanAction";
import { format } from "date-fns";

const NotificationMessage = () => {
  const dispatch = useDispatch();

  const Notificationdata = useSelector(
    (state) => state.feedBackReducer.CategoryRedirectData
  );

  const [notificationData, setNotificationData] = useState([]);
  const [singleData, setSingleData] = useState([]);

  const [isActive, setIsActive] = useState(true);
  const [loading, setLoading] = useState(false);

  const [postModal, setPostModal] = useState(false);
  const [editModal, setEditModal] = useState(false);

  const [editId, setEditId] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [changedRows, setChangedRows] = useState([]); 


  const [formData, setFormData] = useState({
    Type: "",
    Title: "",
    Message: "",
    Redirect: "",
    ScheduledDate: null,
  });
  const isFormInvalid =
    !formData.Type?.trim() ||
    !formData.Title?.trim() ||
    !formData.Message?.trim() ||
    !formData.Redirect ||
    !formData.ScheduledDate;

  const resetForm = () => {
    setFormData({
      Type: "",
      Title: "",
      Message: "",
      Redirect: "",
      ScheduledDate: null,
    });
  };

  const fetchData = async () => {
    setLoading(true);
    const res = await AddUpdate(
      "NotificationMessage/GetData_NotificationMessage",
      {}
    );
    const data = JSON.parse(res?.data?.data);
    const finaldata = data?.Table;

    if (finaldata) setNotificationData(finaldata);

    const enabledIds = finaldata
      .filter((item) => item.IsEnable === true)
      .map((item) => item.NotMsgId);
    setSelectedRows(enabledIds);
  


    setLoading(false);
  };

  const fetchSingleData = async (id) => {
    const res = await AddUpdate(
      "NotificationMessage/GetsinglaData_NotificationMessage",
      { NotMsgId: id }
    );

    if (res?.data?.data) {
      const data = JSON.parse(res?.data?.data);
      const finaldata = data?.Table;

      setSingleData(finaldata);

      setFormData({
        Type: data.Type,
        Title: data.Title,
        Message: data.Message,
        Redirect: data.Redirect,
        ScheduledDate: data.ScheduledDate ? new Date(data.ScheduledDate) : null,
      });
    }
  };

  useEffect(() => {
    dispatch(get_CategoryRedirect("1"));
    fetchData();
  }, []);

  useEffect(() => {
    if (singleData && singleData.length > 0) {
      setFormData({
        Type: singleData[0].Type,
        Title: singleData[0].Title,
        Message: singleData[0].Message,
        Redirect: singleData[0].Redirect,
        ScheduledDate: singleData[0].ScheduledDate
          ? new Date(singleData[0].ScheduledDate)
          : null,
      });
    }
  }, [singleData]);

  useEffect(() => {}, [singleData]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      ScheduledDate: formData.ScheduledDate
        ? format(formData.ScheduledDate, "yyyy-MM-dd hh:mm a")
        : null,
    };

    const res = await AddUpdate(
      "NotificationMessage/Insert_NotificationMessage",
      payload
    );
  

    let parsedData = {};
    try {
      parsedData = JSON.parse(res?.data?.data || "{}");
    } catch (error) {
      console.error("JSON parse error:", error);
    }

    const message = parsedData?.Table?.[0]?.Message;

    if (message === "Sorry This Type Already Exists.") {
      swal("Warning!", "Do not insert duplicate type.", "warning");
    } else if (res?.data?.Message === "Successfully") {
      swal("Good job!", "Successfully Added", "success");
      setPostModal(false);
      resetForm();
      fetchData();
    } else {
      swal("Error!", "Something went wrong. Please try again.", "error");
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    const payload = {
      ...formData,
      NotMsgId: editId,

      ScheduledDate: formData.ScheduledDate
        ? format(formData.ScheduledDate, "yyyy-MM-dd hh:mm a")
        : null,
    };

    const res = await AddUpdate(
      "NotificationMessage/Update_NotificationMessage",
      payload
    );
   

    let parsedData = {};
    try {
      parsedData = JSON.parse(res?.data?.data || "{}");
    } catch (error) {
      console.error("JSON parse error:", error);
    }

    const message = parsedData?.Table?.[0]?.Message;

 if (res?.data?.Message === "Successfully") {
      swal("Good job!", "Successfully Updated", "success");
      setEditModal(false);
      resetForm();
      fetchData();
    } else {
      swal("Error!", "Something went wrong. Please try again.", "error");
    }
  };

  const handleDelete = async (id) => {
    await AddUpdate("NotificationMessage/Delete_NotificationMessage", {
      NotMsgId: id,
    });
    swal("Deleted!", "Notification Message Deleted Successfully", "success");
    fetchData();
  };

const handleCheckboxSelect = (id, isChecked) => {
 
  setNotificationData((prevData) =>
    prevData.map((item) =>
      item.NotMsgId === id ? { ...item, IsEnable: isChecked } : item
    )
  );


  setChangedRows((prev) => {
    const exists = prev.find((row) => row.NotMsgId === id);
    if (exists) {
      return prev.map((row) =>
        row.NotMsgId === id ? { ...row, IsEnable: isChecked } : row
      );
    } else {
      return [...prev, { NotMsgId: id, IsEnable: isChecked }];
    }
  });
};



  const handleEditClick = (row) => {
    setEditId(row.NotMsgId);
    fetchSingleData(row.NotMsgId);
    setEditModal(true);
  };
 
  const columns = [

{
  name: "",
  cell: (row) => (
    <input
      type="checkbox"
      checked={row.IsEnable === true}
      onChange={(e) => handleCheckboxSelect(row.NotMsgId, e.target.checked)}
      style={{ width: "16px", height: "16px", cursor: "pointer" }}
    />
  ),
  width: "70px",
  ignoreRowClick: true,
  allowOverflow: true,
  button: true,
},
,

    { name: "Type", selector: (row) => row.Type, sortable: true },
    { name: "Title", selector: (row) => row.Title, sortable: true },
    { name: "Redirect", selector: (row) => row.Redirect },
    {
      name: "Scheduled Date",
      selector: (row) => {
        if (!row.ScheduledDate || row.ScheduledDate === "1900-01-01T00:00:00") {
          return "-";
        }

        const date = new Date(row.ScheduledDate);

        const localDate = new Date(
          date.getTime() + date.getTimezoneOffset() * 60000
        );

        const day = localDate.getDate().toString().padStart(2, "0");
        const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
        const year = localDate.getFullYear();

        let hours = localDate.getHours();
        const minutes = localDate.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "PM" : "AM";
        hours = hours % 12 || 12;

        const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;

        return formattedDate;
      },
      sortable: true,
    },

    {
      name: "Action",
      cell: (row) => (
        <Dropdown>
          <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                stroke="#342E59"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </Dropdown.Toggle>
          <Dropdown.Menu align="end">
            <Dropdown.Item onClick={() => handleEditClick(row)}>
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              className="text-danger"
              onClick={() => handleDelete(row.NotMsgId)}
            >
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      ),
    },
  ];
  const handleRowSelected = (state) => {
  setSelectedRows(state.selectedRows);
};


const handleupdateSelected = async () => {
  try {
    if (changedRows.length === 0) {
      swal("Warning!", "No changes to update.", "warning");
      return;
    }

   
    const enabledIds = changedRows
      .filter((item) => item.IsEnable === true)
      .map((item) => item.NotMsgId);

    const disabledIds = changedRows
      .filter((item) => item.IsEnable === false)
      .map((item) => item.NotMsgId);

   
    const payloads = [];

    if (enabledIds.length > 0) {
      payloads.push({
        NotMsgId:
          enabledIds.length === 1
            ? `${enabledIds[0]}`
            : `{${enabledIds.join(",")}}`,
        IsEnable: true,
      });
    }

    if (disabledIds.length > 0) {
      payloads.push({
        NotMsgId:
          disabledIds.length === 1
            ? `${disabledIds[0]}`
            : `{${disabledIds.join(",")}}`,
        IsEnable: false,
      });
    }


    for (const payload of payloads) {
     
      const res = await AddUpdate("NotificationMessage/Update_Notification", payload);

      if (res?.data?.Message !== "Successfully") {
        swal("Warning!", `Update failed for ${payload.NotMsgId}`, "warning");
      }
    }


    swal("Success!", "All updates saved successfully!", "success");
    setChangedRows([]);
    await fetchData(); 
   
  } catch (error) {
    console.error("Error updating:", error);
    swal("Error!", "Something went wrong while updating.", "error");
  }
};


  return (
    <>
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>
        Notification Messages
      </h2>
      <Tab.Container defaultActiveKey="All">
        <div className=" d-flex justify-content-between align-items-center flex-wrap ">
          <div
            style={{ marginRight: "40px" }}
            className="card-action coin-tabs"
          >
            <button
              style={{ color: "black" }}
              className="btn btn-sm btn-success"
            onClick={handleupdateSelected}

            >
              {" "}
              Select Update
            </button>
          </div>
          <button
            className="btn btn-primary font-w600"
            onClick={() => {
              setPostModal(true);
              resetForm();
            }}
          >
            + New Notification
          </button>
        </div>

        <Modal
          show={postModal}
          onHide={() => setPostModal(false)}
          backdrop="static"
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="modal-header">
              <h4 className="modal-title fs-20">
                Add Notification
                <span className="text-danger star-error">*</span>
              </h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setPostModal(false)}
              />
            </div>
            <div className="modal-body p-3">
              <div className="form-group mb-2">
                <label>
                  Type<span className="text-danger star-error">*</span>
                </label>
                <input
                  type="text"
                  name="Type"
                  className="form-control"
                  value={formData.Type}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Title<span className="text-danger star-error">*</span>
                </label>
                <input
                  type="text"
                  name="Title"
                  className="form-control"
                  value={formData.Title}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Message<span className="text-danger star-error">*</span>
                </label>
                <textarea
                  name="Message"
                  className="form-control"
                  value={formData.Message}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Redirect<span className="text-danger star-error">*</span>
                </label>
                <select
                  name="Redirect"
                  className="form-control"
                  value={formData.Redirect}
                  onChange={handleInputChange}
                >
                  <option value="">-- Select Redirect --</option>
                  {Notificationdata?.map((item) => (
                    <option key={item.ID} value={item.ID}>
                      {item.Name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mb-2">
                <label>
                  Scheduled Time
                  <span className="text-danger star-error">*</span>
                </label>

                <DatePicker
                  selected={formData.ScheduledDate}
                  onChange={(date) =>
                    setFormData({ ...formData, ScheduledDate: date })
                  }
                  className="form-control"
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={2}
                  dateFormat="yyyy-MM-dd hh:mm aa"
                  placeholderText="Select Date & Time"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleSubmit}
                disabled={isFormInvalid}
              >
                Save
              </button>
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => setPostModal(false)}
              >
                Close
              </button>
            </div>
          </form>
        </Modal>

        <Modal
          show={editModal}
          onHide={() => setEditModal(false)}
          backdrop="static"
        >
          <form onSubmit={(e) => e.preventDefault()}>
            <div className="modal-header">
              <h4 className="modal-title fs-20">Edit Notification</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setEditModal(false)}
              />
            </div>
            <div className="modal-body p-3">
              <div className="form-group mb-2">
                <label>
                  Type<span className="text-danger star-error">*</span>
                </label>
                <input
                  type="text"
                  name="Type"
                  className="form-control"
                  value={formData.Type}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Title<span className="text-danger star-error">*</span>
                </label>
                <input
                  type="text"
                  name="Title"
                  className="form-control"
                  value={formData.Title}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Message<span className="text-danger star-error">*</span>
                </label>
                <textarea
                  name="Message"
                  className="form-control"
                  value={formData.Message}
                  onChange={handleInputChange}
                />
              </div>

              <div className="form-group mb-2">
                <label>
                  Redirect<span className="text-danger star-error">*</span>
                </label>
                <select
                  name="Redirect"
                  className="form-control"
                  value={formData.Redirect}
                  onChange={handleInputChange}
                >
                  <option value="">-- Select Redirect --</option>
                  {Notificationdata?.map((item) => (
                    <option key={item.ID} value={item.ID}>
                      {item.Name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group mb-2">
                <label>
                  Scheduled Date
                  <span className="text-danger star-error">*</span>
                </label>
                <DatePicker
                  selected={formData.ScheduledDate}
                  onChange={(date) =>
                    setFormData({ ...formData, ScheduledDate: date })
                  }
                  className="form-control"
                  showTimeSelect
                  timeFormat="hh:mm aa"
                  timeIntervals={2}
                  dateFormat="yyyy-MM-dd hh:mm aa"
                  placeholderText="Select Date & Time"
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                className="btn btn-primary"
                type="button"
                onClick={handleUpdate}
                disabled={isFormInvalid}
              >
                Update
              </button>
              <button
                className="btn btn-danger"
                type="button"
                onClick={() => setEditModal(false)}
              >
                Close
              </button>
            </div>
          </form>
        </Modal>

        <div className="col-12 mt-2">
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div style={{ flexGrow: 1 }}>
                <DataTable
      dense
      data={notificationData}
      columns={columns}
      pagination
      persistTableHead
      noDataComponent="No data available"
      customStyles={customStyles}
      // selectableRows
      onSelectedRowsChange={handleRowSelected} 
      selectableRowsHighlight
    />
                
              </div>
            </div>
          )}
        </div>
      </Tab.Container>
    </>
  );
};

export default NotificationMessage;
